module.exports = require('./dist/style')



//////////////////
// WEBPACK FOOTER
// ./~/styled-jsx/style.js
// module id = ./node_modules/styled-jsx/style.js
// module chunks = 0 1